<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12"><div class="queryinput">
        <el-input v-model="bucketname" placeholder="请输入新的Bucket名称"></el-input>
      </div></el-col>
      <el-col :span="12">
        <div>
          <el-button style="margin-left: 15px" @click="createbucket">创建新Bucket</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-col :span="24">
        <div class="tablepanel">
            <el-table
            stripe
            :data="bucketdata"
            ref="multipleTable">
              <el-table-column
                type="index"
                width="50">
              </el-table-column>
            <el-table-column
              prop="bucketname"
              label="Bucket名称">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除Bucket" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delbucket(scope.$index, bucketdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$http = axios
var that
export default {
  name: 'BucketMana',
  data () {
    return {
      bucketdata: [],
      khid: '',
      bucketname: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listbucket',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var bmlist = JSON.parse(res.data.data)
            var bmdata = []
            for (var j = 0; j < bmlist.length; j++) {
              var stmp = bmlist[j]
              let datatmp = {
                bucketname: stmp
              }
              bmdata.push(datatmp)
            }
            that.bucketdata = bmdata
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    delbucket (index, data) {
      console.log(data[index])
      var deldata = {
        bucketname: data[index].bucketname
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/delbucket',
        method: 'post',
        data: deldata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/oss/listbucket',
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                if (res.data.success) {
                  var bmlist = JSON.parse(res.data.data)
                  var bmdata = []
                  for (var j = 0; j < bmlist.length; j++) {
                    var stmp = bmlist[j]
                    let datatmp = {
                      bucketname: stmp
                    }
                    bmdata.push(datatmp)
                  }
                  that.bucketdata = bmdata
                  that.$message({
                    type: 'success',
                    message: '创建成功！'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    createbucket () {
      if (this.bucketname === '' || this.bucketname === null) {
        that.$message({
          type: 'info',
          message: 'Bucket名称不允许为空！'
        })
      } else {
        var createdata = {
          bucketname: this.bucketname
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/oss/createbucket',
          method: 'post',
          data: createdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/oss/listbucket',
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  if (res.data.success) {
                    var bmlist = JSON.parse(res.data.data)
                    var bmdata = []
                    for (var j = 0; j < bmlist.length; j++) {
                      var stmp = bmlist[j]
                      let datatmp = {
                        bucketname: stmp
                      }
                      bmdata.push(datatmp)
                    }
                    that.bucketdata = bmdata
                    that.$message({
                      type: 'success',
                      message: '创建成功！'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/oss/BucketMana.vue